/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para las estadísticas agregadas de un equipo en una temporada. (Victorias, Derrotas, Empates, Goles).
 */
export interface TeamSeasonStatsDTO { 
    total_matches: number;
    wins: number;
    losses: number;
    draws: number;
    goals_for: number;
    goals_against: number;
}

